import axios from "axios";

export default {
  getIntegrationLogs(request) {
    return axios.post(`Logging/SearchIntegrationLogs`, request);
  },
  getPermissionLogs(request, config) {
    return axios.post(`Logging/SearchPermissionLogs`, request, config);
  },
  deletePermissionLogsByIds(data) {
    return axios.delete(`Logging/DeletePermissionLogs`, {data});
  },
  deleteIntegrationLogsByIds(data) {
    return axios.delete(`Logging/DeleteIntegrationLogs`, {data});
  }
};
